import React from "react";

import { ButtonView } from "common/views/button/Button.view";
import HeadingView from "common/views/heading/Heading.view";
import { ImageView } from "common/views/image/Image.view";
import ProgressBarView from "common/views/progressBar/ProgressBar.view";
import TypographyView from "common/views/typographyView/Typography.view";
import { Fragment } from "core/components/FragmentProvider";
import Label from "core/components/label/Label";
import Program from "panels/program/entities/Program";
import labelProvider from "panels/program/Program.labels";

const { Labels } = labelProvider;

interface IProgramDisplayProps {
	program: Program;
}

export const title: Fragment<IProgramDisplayProps> = {
	name: "Title",
	component: ({program}) => (
		<HeadingView viewKey="program.title">
			<Label k={`Program.${program.id}.name`} v={program.name} />
		</HeadingView>
	)
};

export const description: Fragment<IProgramDisplayProps> = {
	name: "Description",
	enabled: ({program}) => !!program.description,
	component: ({program}) => (
		<TypographyView viewKey="program.description">
			<Label k={`Program.${description}.description`} v={program.description} allowHtml={true} type="html" />
		</TypographyView>
	)
};

export const progress: Fragment<IProgramDisplayProps> = {
	name: "Progress",
	enabled: ({program}) => !!program.progress,
	component: ({program}) => (
		<ProgressBarView value={0} viewKey="program.progress" />
	)
};

export const enroll: Fragment<IProgramDisplayProps> = {
	name: "Enroll",
	enabled: ({program}) => false,
	component: ({program}) => (
		<div>
			enroll info here
		</div>
	)
};

export const badges: Fragment<IProgramDisplayProps> = {
	name: "Program Badges",
	enabled: ({program}) => !!program.badges && program.badges.length > 0,

	// not using labels for badges since acclaim doesn't support translations?
	component: ({program}) => (
		<div>
			{program.badges.map((badge) => (
				<div key={badge.id}>
					<ImageView viewKey="badge.icon" src={badge.imageUrl} style={{width: 100, height: 100}} />
					<TypographyView viewKey="badge.title">
						{badge.title}
					</TypographyView>
					{
						!!badge.issuedAt ? (
							<Labels.BadgeIssuedAt args={{date: new Date(badge.issuedAt)}} />
						) : (
							<ButtonView viewKey="badge.claim" disabled={!badge.pending}>
								<Labels.BadgeClaim />
							</ButtonView>
						)
					}
				</div>
			))}
		</div>
	)
};

export const checklist: Fragment<IProgramDisplayProps> = {
	name: "Checklist",
	component: ({program}) => {
		return (
			<div>
				(AFP checklist)
			</div>
		);
	}
};




// WEBPACK FOOTER //
// ./src/panels/program/fragments/program/displayFragments.tsx